import { PERMISSION } from '../utils/constants';
import axiosClient from './axiosClient';

export const positionFinderApi = {
  getPositionFilters: (params) => {
    return axiosClient.get(`/position-finder/get-filters`, {
      params,
    });
  },

  getPositionDataList: (body, role, permission) => {
    const url = `/position-finder/get-info`;
    return axiosClient.post(url, body, {
      headers: {
        role: role.roleId,
        permission,
      },
    });
  },

  requestPositionDataExport: (body, role) => {
    const url = `/position-finder/export`;
    return axiosClient.post(url, body, {
      headers: {
        role: role.roleId,
        permission: PERMISSION.EXPORT_POSITION,
      },
    });
  },
};

export default positionFinderApi;
